import { Component, HostListener, OnInit } from "@angular/core";
import { PaginationInstance } from "ngx-pagination";
import { ActivatedRoute } from "@angular/router";
import { Product } from "../../../objects/products/product";
import { ProductService } from "../../../services/productService";
import { ProductSearchRequest } from "../../../objects/requests/productSearchRequest";
import { RequestType } from "../../../objects/products/requestType";
import { BlurUtil } from "../../../common/utils/blurUtil";
/**
 * Created by alex.y on 9/11/2017.
 */

@Component({
    selector: 'product-management',
    templateUrl: 'productManagement.component.html',
    moduleId: module.id.toString()
})
export class ProductManagementComponent implements OnInit {
    public query: string;
    public products: Product[] = [];

    public idToBlur: string = "product-management";

    public config: PaginationInstance = {
        id: 'custom',
        itemsPerPage: 12,
        currentPage: 1,
        totalItems: 1
    };

    constructor(private route: ActivatedRoute, public productService: ProductService) {

    }

    @HostListener('window:popstate', ['$event'])
    unBlurMenu(): void {
        BlurUtil.unBlurMenu(this.idToBlur);
    }

    public ngOnInit(): void {
        this.config.totalItems = this.route.snapshot.data.products.TotalCount;
        this.products = this.route.snapshot.data.products.Items;
    }

    public search(): void {
        this.productService.search(new ProductSearchRequest({
            Skip: (this.config.currentPage - 1) * this.config.itemsPerPage,
            Top: this.config.itemsPerPage,
            Query: this.query,
            Source: null,
            RequestType: RequestType.Search
        })).then(users => {
            this.products = users.Data.Items;
            this.config.totalItems = users.Data.TotalCount;

            document.getElementById('mainPanel').scrollTop = 0;
        }).catch(response => {
            this.products.splice(0, this.products.length);
        });
    }

    public onProductSaved(product: Product): void {
        let existingProduct = this.products.find(x => x.Id == product.Id);

        if (existingProduct != null) {
            Object.assign(existingProduct, product);
        } else {
            this.products.unshift(product);
            this.products.pop();
            this.config.totalItems += 1;
        }
    }

}


// WEBPACK FOOTER //
// ./app/components/Managment/productManagement/productManagement.component.ts